import React, { PureComponent } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import looppa from 'looppa';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';

import { Trans } from 'translations';
import { PRODUCT_LIST_PRODUCT_SLIDER } from 'tracking/constants';
import ProductTile from 'components/product-tile';
import Slider from 'components/slider';
import Icon from 'components/icon';
import sliderConfig, { productTileAmounts } from './slider-config';
import SliderHeader from 'components/products-slider-header';

import { getViewportData } from 'util/dom/mq';

class ProductsSlider extends PureComponent {
    static propTypes = {
        slug: PropTypes.string,
        link_label_key: PropTypes.string,
        header_link_label_key: PropTypes.string,
        title: PropTypes.string,
        skipTests: PropTypes.bool,
        promotionalTile: PropTypes.bool,
        link: PropTypes.string,
        products: PropTypes.array.isRequired,
        historyPush: PropTypes.func.isRequired,
        isMobile: PropTypes.bool.isRequired,
        isTablet: PropTypes.bool.isRequired,
        isTouch: PropTypes.bool.isRequired,
        viewportMqWidth: PropTypes.number.isRequired,
    };

    static defaultProps = {
        promotionalTile: true,
        header_link_label_key: null,
        link: null,
    };

    /**
     * Calculate the amount of empty slots to fill the slider
     *
     * @param {number} maxItems
     * @param {number} amountPerRow
     * @return {number}
     */
    numberOfItems(maxItems, amountPerRow) {
        const promotionalTileOffset = this.props.promotionalTile ? 1 : 0;
        return amountPerRow - maxItems % amountPerRow - promotionalTileOffset;
    }

    /**
     * Get list of products including fake ones to fill the slider
     *
     * @return {Array<IProduct | null>}
     */
    get trimmedProducts() {
        let { products, promotionalTile } = this.props;

        // Render a maximum of 4 rows in slider; row-size depends on the current viewport
        const amountPerRow = productTileAmounts[getViewportData().query];
        const maxItems = Math.min(amountPerRow * 4 - 1, products.length);
        const promotionalTileOffset = promotionalTile ? 1 : 0;

        // Add placeholders if there are not enough items to fill one row
        if (products.length < amountPerRow - promotionalTileOffset) {
            const numberOfItems = this.numberOfItems(maxItems, amountPerRow);
            const placeholders = Array(numberOfItems).fill(null);
            products = products.slice(0, maxItems).concat(placeholders);
        }

        return products;
    }

    renderPromotionalTile() {
        const { link, isMobile, historyPush, promotionalTile, link_label_key } = this.props;
        if (!promotionalTile || !link) {
            return null;
        }

        return (
            <article
                onClick={ () => {
                    // on mobile the whole tile surface should be a link
                    if (isMobile) {
                        historyPush(link);
                    }
                } }
                className="products-slider--show-promotions"
                key={ 'show-promotions' }
            >
                <NavLink to={ link } className="products-slider--show-promotions-text u-reset">
                    <Trans path={ link_label_key ? link_label_key : 'categories.show_all' }/>
                </NavLink>

                <NavLink to={ link } className="products-slider--show-promotions-icon u-reset">
                    <Icon symbol="productslider-right" size="medium"/>
                </NavLink>
            </article>
        );
    }

    render() {
        const { title, link, slug, isMobile, skipTests, isTouch, isTablet, promotionalTile, link_label_key, header_link_label_key } = this.props;
        return (
            <div className="products-slider">
                { title && <SliderHeader title={ title } link={ link } link_label_key={ header_link_label_key || link_label_key }/> }

                <Slider
                    useNativeScroll={ isMobile || (isTablet && isTouch) }
                    facet={ 'products-slider' }
                    config={ sliderConfig }>
                    { looppa(this.trimmedProducts)((product, index) => (
                        <ProductTile
                            basePath={ slug }
                            { ...product }
                            position={ index }
                            skipTests={ skipTests }
                            facet={ product ? 'overview' : 'placeholder' }
                            list={ PRODUCT_LIST_PRODUCT_SLIDER }
                            key={ product && product.id ? product.id : index }/>
                    )).concat((promotionalTile && link) ? [this.renderPromotionalTile()] : []) }
                </Slider>
            </div>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        viewportMqWidth: 'viewport.mq.width',
        isMobile: 'viewport.isMobile',
        isTablet: 'viewport.isTablet',
        isTouch: 'viewport.touchevents',
        historyPush: 'router.history.push',
    }),
)(ProductsSlider);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/products-slider/index.js